
<template>
    <div class="content-wrap">
      <!-- 영업기회ID -->
      <div>
        <div class="search-wrap">
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <ElLabel name="코드ID">
                  <template v-slot:end="slotProps">
                    <ElInput :id="slotProps.id" v-model="state.searchParams.cd_gr" @inputKeyupEnter="getDataList()"/>
                  </template>
                </ElLabel>
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <ElLabel name="코드명">
                  <template v-slot:end="slotProps">
                    <ElInput :id="slotProps.id" v-model="state.searchParams.cd_nm" @inputKeyupEnter="getDataList()"/>
                  </template>
                </ElLabel>
              </div>
            </div>
          </div>
        </div>
        <div class="search-detail-wrap"></div>
          <div class="text-end py-2">
            <ElButton type="search" @buttonClick="getDataList()">검색</ElButton>
          </div>
          <div class="d-flex justify-content-between">
            <div></div>
            <div class="table-btn-group">
              <ElButton type="excelDownload" @buttonClick="excelDownload()">엑셀다운</ElButton>
            </div>
          </div>
          <!-- 그리드 영역 -->
          <div class="table-responsive table-list table-cf">
            <DataTable 
              :value="state.gridRowData"  
              editMode="cell"
              :paginator="true" 
              :rows="10" 
              :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
              @cell-edit-complete="onCellEditComplete"
              scrollable
              scrollHeight="400px"
              :pt="{
                  column: {
                      bodycell: ({ state }) => ({
                          class: [{ 'pt-0 pb-0': state['d_editing'] }]
                      })
                  }
                }"
            >
            <template #empty>데이터가 존재하지 않습니다.</template>
            <!--체크박스 컬럼-->
              <Column style="width: 40px" >
                <template #header>
                  <ElCheckbox v-model="allCheck"/>
                </template>
                <template #body="{data}">
                  <ElCheckbox 
                    v-model="state.selectRows" 
                    :value="data"
                  />
                </template>
              </Column>

              <!--데이터 매핑 컬럼-->
              <Column 
                v-for="code of state.gridColumn" 
                :field="code.field" 
                :header="code.headerName"
                :key="code.field" 
                :style="code.style"
              >
                <template #editor="{ data, field }">
                  <ElInput
                    v-if="field != 'use_yn' && field != 'del_yn' && field != 'reg_id' && field != 'fmt_reg_dt' && field != 'fmt_upd_dt'"
                    :modelValue="data[field]"
                    @update:modelValue="r=>changeVal(r,data,field)"
                  />
                  <select
                    v-else-if="field == 'use_yn' || field == 'del_yn'"
                    class="form-select"
                    aria-label="Default select example"
                    @input="changeVal($event.target.value,data,field)"
                  >
                    <option :value="'Y'">Y</option>
                    <option :value="'N'">N</option>
                  </select>
                  <span v-else-if="field == 'use_yn' && header == '사용여부'|| field == 'del_yn' && header == '삭제여부'"  class="centered-text" >{{ data[field] }}</span>
                  <span v-else :unstyled>{{ data[field] }}</span>
                </template>
              </Column>
            </DataTable>
          </div>
          <div class="text-end py-2">
              <ElButton type="primary" @buttonClick="addRow()">추가</ElButton>
              <ElButton type="primary" @buttonClick="saveRow()">저장</ElButton>
              <ElButton type="primary" @buttonClick="deleteRow()">삭제</ElButton>
          </div>
    </div> <!--The end of row class block   -->
  </div>
  <ExcelManage
    v-show="false"
    ref="excelManage"
  />
</template>
     
<script setup>   
import {reactive,onBeforeMount,computed,ref} from 'vue'
import ExcelManage   from '@/components/common/MCO_EX_001.vue'
import DataTable     from 'primevue/datatable'
import Column        from 'primevue/column'

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { codeGrpDtlEdit, codeGrpDtlList } from '@/api/conf'
const excelManage = ref()

onBeforeMount(async () => { await getDataList(); })

//변수 선언 영역 
const state = reactive({
  gridColumn : [
    { headerName: '코드ID', field: "cd_gr", style: {minWidth: '100px', maxWidth:'120px'}},
      { headerName: '상세코드ID', field: "cd_id", style: {minWidth: '100px',maxWidth:'120px' }},
      { headerName: '코드명', field: "cd_nm",  style: {minWidth: '150px',maxWidth:'150px' }},
      { headerName: '코드 상세', field: "cd_val", style: {minWidth: '200px',maxWidth:'200px' }},
      { headerName: '순번', field: "sort_ord", style: {minWidth: '100px',maxWidth:'100px' }},
      { headerName: '사용여부', field: "use_yn", style: {textAlign : 'center',minWidth: '85px',maxWidth:'100' }},
      { headerName: '삭제여부', field: "del_yn", style: {textAlign : 'center',minWidth: '85px',maxWidth:'100px' }},
      { headerName: '등록자', field: "reg_id",  style: {minWidth: '100px' }},
      { headerName: '등록일', field: "fmt_reg_dt", style: {minWidth: '100px' }},
      { headerName: '수정일', field: "fmt_upd_dt", style: {minWidth: '120px' }}

  ],
  gridRowData :[],
  selectRows : [],
  searchParams : {
      cd_id : '',
      cd_nm : '',
      page_count : 1,
      unit_count : 100000,
  },
  // updateCheck: false,
})

const allCheck = computed({
  get(){
      return state.gridRowData.length === state.selectRows.length;
  },
  set(newValue){
      state.selectRows = newValue ? state.gridRowData.map((item)=>{return item}) : [];
  }
})

//행 추가 함수
const addRow = () => {
  state.gridRowData.push({
    cd_gr:'',
    cd_id: '',
    cd_nm : '',
    cd_val : '',
    sort_ord : '',
    use_yn : 'Y',
    del_yn : 'N',
    reg_id : '',
    fmt_reg_dt : '',
    flag : 'C'
  })
};

const deleteRow = async (data)=>{

if(confirm(state.selectRows.length +" 건 선택하신 항목을 삭제 하시겠습니까?")==true) {
  state.gridRowData.value = data;

  let params = {
    codeGrpDtlVOList : state.selectRows
  } 

  for(let item of params.codeGrpDtlVOList){
      item['flag'] = 'D'
  }

  if(params.codeGrpDtlVOList.length > 0 ) {
      try {
        setIsLoading(true)
        const res = await codeGrpDtlEdit(params)
        alert(params.codeGrpDtlVOList.length + '건 삭제완료!!') 
        await getDataList()
      } catch (err) {
        console.error('error', err)
        alert('코드 삭제 에러')
      } finally {
        setIsLoading(false)
      }
  }else {
    alert('선택된 행이 없습니다.')
  }
}
};

//저장 함수
const saveRow = async (data) => {

if(confirm(state.selectRows.length +" 건 선택하신 항목을 저장 하시겠습니까?")==true) {    

  state.gridRowData.value = data;

  let params = {
      codeGrpDtlVOList : [...state.selectRows]
  }

  for(let item of params.codeGrpDtlVOList){
    if(item?.index === 0 || item?.index){
      item['flag'] = 'U'
    }else{
      item['flag'] = 'C'
    }
  }

  if(params.codeGrpDtlVOList.length > 0 ){
      try {
        setIsLoading(true)
        const res = await codeGrpDtlEdit(params)
        
        alert(params.codeGrpDtlVOList.length + '건 저장완료!!') 
        await getDataList()
      } catch (err) {
        console.error('error', err)
        alert('코드 등록&수정 에러')
      } finally {
        setIsLoading(false)
      }
  } 
  else {
      alert('선택된 행이 없습니다.')
  }
}
};

const getDataList = async () =>{

  let params = {
    cd_gr  : state.searchParams.cd_gr,
    cd_nm  : state.searchParams.cd_nm
  };
  try {
    setIsLoading(true)
    const res = await codeGrpDtlList(params)
    state.selectRows = []
    state.gridRowData = res.rtn.map((item,index)=>{
      item.index = index
      return item
    })
  } catch (err) {
    console.error('/conf/codeGrpDtlList ERROR!! => ' + err)
    alert('api 에러 발생!!')
  } finally {
    setIsLoading(false)
  }
  
  // state.updateCheck = false;
}

const excelDownload = () =>{
let fileNm = '코드관리'
let header = state.gridColumn
let dataList = state.gridRowData
if(state.selectRows?.length > 0){
  dataList = state.selectRows
}

excelManage.value.excelDownload(fileNm,header,dataList)
}

const onCellEditComplete = (code) => {
  let { data,newValue, field } = code;

  data[field] = newValue

};

const changeVal = (val,data,filed)=>{

  data[filed] = val
}
// const moveToPage = (routerName) => {
//   vueRouterCmn.routerPush(routerName)
// }

// const onRowSelect = (event) =>{
//   if(event.type == 'row'){
//     vueRouterCmn.routerPush('MSH_SR_001',{mng_seq : event.data.mng_seq})
//   }
// }

</script>
